import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Plateform() {
  return (
    <section className="selah_idea p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto order-md-1 order-2"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/selah/tek_img_03.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={720}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="offset-xl-1 my-auto order-md-2 order-1"
          >
            <h2>
              Main
              <span style={{ color: "#00ADEF" }}> Features</span>
            </h2>
            <p>
              These are the features that helped Selah become the #1 social
              networking platform to interact with family and close friends:
            </p>
            <h6>1. Family Tree</h6>
            <p>
              As the name suggests, the Family Tree feature helps people find
              and connect with their family members and relatives. This feature
              helps people connect with their long-distance relatives. For
              instance, anyone within the user’s connection can access the
              family tree to find and connect their family members and relatives
              using Selah. And yes, you can disable this feature on the app if
              you don't want to show your family tree to anyone on Selah.
            </p>
            <h6>2. Family Map</h6>
            <p>
              The Family Map feature helps people find their connections' most
              significant experiences and past events details. It means you can
              search the users' profiles and access all the past events and
              celebrations they have made publicly available on the platform,
              such as birthdays, graduation ceremonies, weddings, traveling,
              etc. And similar to the family tree, you can disable this feature
              whenever you want.
            </p>
            <h6>3. Activity Tab</h6>
            <p>
              The Activity tab is similar to newsfeeds on other social
              platforms, but it's reserved only for the family. You can share
              whatever you want with your close ones – like you had dental
              surgery today, won a football competition, purchased a new phone,
              got engaged the following weekend, etc., and the people in your
              network will get an instant notification of the update.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Plateform;
